import { Fragment } from "react";
import { Stack, IStackProps } from "@fluentui/react/lib/Stack";
import { useCardStyles } from "./UseCardStyles";
import { ICardProps } from "./ICardProps";
import { isNullOrWhiteSpace, isString } from "../../../Utils/String";
import { hasElements } from "../../../Utils/Array";

export function Card(props: ICardProps): JSX.Element {
  const { header, children, styleSet } = props;
  const styles = useCardStyles(styleSet);

  const isList = Array.isArray(children) && hasElements(children);
  const horizontal: IStackProps = isList ? { horizontal: true, horizontalAlign: `space-between`, wrap: true } : {};

  return (
    <Stack className={styles.root} {...horizontal} grow>
      {isNullHeader(header)
        ? null
        : (
          <Stack.Item grow={false} disableShrink className={styles.header}>
            {header}
          </Stack.Item>
        )}
      {!Array.isArray(children)
        ? (
          <Stack className={styles.content} grow disableShrink>
            {children}
          </Stack>
        )
        : (
          children.map((child, index, list) => (
            <Fragment key={child.key}>
              <Stack grow={1} key={`${child.key}-content`} className={styles.column} horizontal horizontalAlign="start">
                <Stack.Item>{child}</Stack.Item>
              </Stack>
              {list.length > 1 && index < list.length - 1
                ? (
                  <Stack key={`${child.key}-separator`} className={styles.column} horizontal horizontalAlign="start">
                    <Stack.Item>
                      <hr />
                    </Stack.Item>
                  </Stack>
                )
                : null}
            </Fragment>
          ))
        )}
    </Stack>
  );
}

function isNullHeader(header: string | JSX.Element): boolean {
  if (isString(header)) {
    return isNullOrWhiteSpace(header);
  }

  return header == null;
}
